import { createAction, props } from '@ngrx/store';
import { IJournalStatus } from '../../../../entities/src/lib/definitions/i-journal-status';

export const loadTillStatus = createAction(
  '[TillStatus] Load TillStatus',
  props<{ payload: { entityId: string; locationId: string } }>()
);

export const setOpenCashPosition = createAction(
  '[TillStatus] Set Open Cash Position',
  props<{
    payload: {
      entityId: string;
      locationId: string;
      amount: number;
      comment?: string;
    };
  }>()
);

export const closeCashPosition = createAction(
  '[TillStatus] Close Cash Position',
  props<{
    payload: {
      entityId: string;
      locationId: string;
      amount: number;
      comment?: string;
    };
  }>()
);

export const loadTillStatusSuccess = createAction(
  '[TillStatus] Load TillStatus Success',
  props<{ payload: IJournalStatus }>()
);

export const loadTillStatusFailure = createAction(
  '[TillStatus] Load TillStatus Failure',
  props<{ error: any }>()
);

export const clearTillStatus = createAction('[TillStatus] Clear TillStatus');
